import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Create from "../components/Voucher/Create";
import Edit from "../components/Voucher/Edit";
import Loading from "../components/Loading";
import api from "../api/api";
import { Button, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const Voucher = () => {
  const [step, setStep] = useState("");
  const [cupom, setCupom] = useState([]);
  const [idToEdit, setIdToEdit] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (step !== "") return;

    const fetchVouchers = async () => {
      setIsLoading(true);
      try {
        const res = await api.get("vouchers");
        if (res.status === 200) {
          setCupom(res.data.vouchers);
        } else {
          setCupom([]);
          console.error("Erro ao carregar os cupons.");
        }
      } catch (error) {
        console.error("Erro ao buscar cupons:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVouchers();
  }, [step]);

  const handleCreateClick = () => setStep("create");
  const handleEditClick = (id) => {
    setIdToEdit(id);
    setStep("edit");
    console.log("click no Edit");
  };

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl shadow-lg">
      <Header category="Promoções" title="Cupons" />

      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-64">
          <CircularProgress size={60} />
          <p className="mt-4 text-gray-600">Carregando cupons...</p>
        </div>
      ) : step === "create" ? (
        <Create setStep={setStep} />
      ) : step === "edit" ? (
        <Edit setStep={setStep} cupomId={idToEdit} />
      ) : step === "" && cupom.length > 0 ? (
        <div className="mt-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-800 mb-2">
                Gerenciar Cupons
              </h1>
              <p className="text-gray-600">
                Total de cupons:{" "}
                <span className="font-semibold text-blue-600">
                  {cupom.length}
                </span>
              </p>
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateClick}
              className="px-6 py-3"
            >
              <div className="flex items-center gap-2">
                <AddIcon />
                Criar Novo Cupom
              </div>
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {cupom.map((coupon) => (
              <div
                key={coupon.id}
                className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 hover:border-blue-300 p-4"
              >
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-lg font-semibold text-gray-800 line-clamp-2 flex-1 mr-3">
                    {coupon.name}
                  </h3>
                  <button
                    className="px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600 transition-colors flex-shrink-0"
                    onClick={() => handleEditClick(coupon.id)}
                  >
                    Editar
                  </button>
                </div>

                <div className="space-y-2">
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {coupon.description}
                  </p>

                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Código:</span>
                      <span className="font-mono font-semibold text-blue-600">
                        {coupon.code}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Desconto:</span>
                      <span className="font-semibold text-green-600">
                        {coupon.discount}%
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Uso único:</span>
                      <span
                        className={`font-semibold ${
                          coupon.isUnique ? "text-green-600" : "text-orange-600"
                        }`}
                      >
                        {coupon.isUnique ? "Sim" : "Não"}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">
                        Exibir na conta do cliente:
                      </span>
                      <span
                        className={`font-semibold ${
                          coupon.showInStore
                            ? "text-green-600"
                            : "text-orange-600"
                        }`}
                      >
                        {coupon.showInStore ? "Sim" : "Não"}
                      </span>
                    </div>
                  </div>

                  <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                    <div className="text-sm">
                      <span className="text-gray-600">Expira em: </span>
                      <span className="font-semibold text-red-600">
                        {new Intl.DateTimeFormat("pt-BR").format(
                          new Date(coupon.expiresIn),
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="mt-6 text-center py-12">
          <div className="text-gray-400 mb-4">
            <svg
              className="w-16 h-16 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
              />
            </svg>
          </div>
          <p className="text-gray-500 text-lg mb-4">Nenhum cupom encontrado</p>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateClick}
            className="px-6 py-3"
          >
            <div className="flex items-center gap-2">
              <AddIcon />
              Criar Primeiro Cupom
            </div>
          </Button>
        </div>
      )}
    </div>
  );
};

export default Voucher;
